<template>
  <v-sheet>
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" md="4" lg="6" style="justify-content: center; text-align: center">
          <h1 style="color: #001E4A; font-size: 30px">
            {{ $t('partners.title') }}
          </h1>
          <p style="font-size: 18px">
            {{ $t('partners.subtitle') }}
          </p>
        </v-col>
        <v-col cols="12" md="6" lg="5">
          <v-img class="rounded-lg" :src="Clientes" alt=""> </v-img>
        </v-col>
      </v-row>
    </v-container>
    <div id="waveButtonBlack"></div>
  </v-sheet>
</template>

<script>
import Clientes from 'Assets/Landing/Parceiros.png';
export default {
  name: 'Partners',
  data() {
    return {
      Clientes,
    };
  },
  components: {},
  methods: {
    openNewTab(link) {
      window.open(link);
    },
  },
};
</script>
<style>
#waveButtonBlack {
  position: relative;
  height: 90px;
  width: '100%';
  background: #222222;
}
#waveButtonBlack:after {
  content: '';
  display: block;
  border-radius: 0% 0% 100% 100%;
  width: '120%';
  height: 90px;
  background-color: white;
  right: -5px;
  transform: rotate(0deg);
}
#waveTopBlack {
  position: relative;
  height: 90px;
  width: '100%';
  background: #222222;
}
#waveTopBlack:after {
  content: '';
  display: block;
  border-radius: 100% 100% 0% 0%;
  width: '120%';
  height: 90px;
  background-color: white;
  right: -5px;
  transform: rotate(0deg);
}
</style>
